import Graph from './graph';
import Style from './style';
import Markup from './markup';

import StepsController from './controllers/steps';

export default class Fluxogram {
  constructor() {
    this.graph = new Graph();
    this.style = new Style();
    this.markup = new Markup(this.graph, this.style);
  }

  initialize(steps) {
    this.graph.clearCode();
    this.style.clear();

    const stepsController = new StepsController(this.graph, this.style, steps);

    stepsController.initialize();
  }

  build(steps, holderNode) {
    if (steps.length <= 1) {
      return null;
    }

    this.initialize(steps);

    return this.markup.build(holderNode);
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/fluxogram/index.js
 **/